import { Outlet, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import styles from "./index.module.scss";
import useAuth from "../Hooks/useAuth";
import { useCallback, useEffect, useLayoutEffect, useMemo, useState } from "react";
import { UsersRestS } from "../../rest/users-rest-service";
import { GASendEvent, getCapital, getLocalUser, login } from "../functions/utilities";
import { useLocation } from "react-router-dom";
import InfoCard from "../common/InfoCard/InfoCard";
import Chip from "../common/Chip/Chip";
import sparkleGif from '../../assets/images/sparkle.gif';
import { SI_INFOCARD_PAGES, SI_PROMO_CONFIG_KEYS, isSIPromoEnabled } from "../../constants/promotionKeys";
import { trackSIPromoShown, trackSIPromoDismissed, trackSIPromoButtonClicked } from "../../pages/GSTReconciliation/siPromoAmplitude";
import { useDispatch, useSelector } from "react-redux";
import useSocketOnIndex from "../Hooks/useSocketOnIndex";
// import toast, { Toaster } from 'react-hot-toast';
import { AiOutlineClose as CloseIcon } from "react-icons/ai";
import { getParsedMessage, getRelativeTime } from "../functions/utilities";
import moment, { duration } from "moment";
import {
    GADimensions,
    GAEvents,
    Notification,
    ToastifyStatus,
} from "../../interfaces/interfaces";
import { RestS } from "../../rest/rest-service";
import { useAppDispatch, useAppSelector } from "../../redux/reduxHooks";
import { changeResetStatus } from "../../redux/notifications/notificationSlice";
import { resetFromCollaboration } from "../../redux/chat/chatSlice";
import { ToastContainer, toast } from "react-toastify";
import "./overrideToastify.css";
import { MdKeyboardArrowRight } from "react-icons/md";
import DisbursementSections from "../../pages/Disbursement/DisbursementSections";
import ShareholdersRevamp from "../../pages/Underwriting/CompanyDetails/ShareholdersRevamp";
import MeritoButton from "../common/MeritoButtons/MeritoButtons";

export const NotificationMsg = ({
    closeToast,
    onClickFlashMessage,
    notification,
}) => {
    console.log(notification?.notificationBody)
    return (
        <div className={styles.notificationBar}>
            <div
                className={`${styles.statusBar} 
        ${!notification?.notificationBody?.status
                        ? ""
                        : notification?.notificationBody?.status == ToastifyStatus.success
                            ? styles.green
                            : styles.red
                    }`}
            ></div>
            <div className={styles.notificationMain} style={{ background: notification.notificationBody?.background ? notification.notificationBody?.background : 'white' }}>
                <div
                    className={styles.body}
                    onClick={() => {
                        onClickFlashMessage();
                        closeToast();
                    }}
                >
                    <div>{getParsedMessage(notification.notificationBody["title"])}</div>
                    {!notification.notificationBody["hideSubTitle"] ?
                        <div className={styles.time}>
                            {notification.notificationBody["subTitle"]
                                ? getParsedMessage(notification.notificationBody["subTitle"])
                                : getRelativeTime(notification.sendTime)}
                        </div> : null
                    }
                    {notification?.notificationBody?.buttonText && (
                        <div
                            className={styles.buttonContainer}
                            onClick={() => {
                                if (notification?.notificationBody?.buttonAction)
                                    notification?.notificationBody?.buttonAction();
                            }}
                        >
                            <div className={styles.buttonText}>
                                {notification?.notificationBody?.buttonText}
                            </div>
                            <MdKeyboardArrowRight className={styles.rightArrow} />
                        </div>
                    )}
                    {notification?.notificationBody?.primaryButtonText && (
                        <div>
                            <MeritoButton type="primary-1" btnText={notification?.notificationBody?.primaryButtonText} onClick={() => {
                                if (notification?.notificationBody?.buttonAction)
                                    notification?.notificationBody?.buttonAction();
                            }} />
                        </div>
                    )}
                </div>
                <div className={styles.removeContainer} onClick={closeToast}>
                    <CloseIcon />
                </div>
            </div>
        </div>
    );
};

function Layout() {
    let [auth, setAuth] = useState(useAuth());
    const user = getLocalUser();
    let [blurScreen, setBlurScreen] = useState<boolean>(false);
    const helppopup = useSelector((state: any) => state.popover);
    const workspace = useSelector((state: any) => state.workspace);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const noSideBarLocation = ["workspacestore", "activate"];
    const [headerContent, setHeaderContent] = useState<JSX.Element>(null);
    const [rightHeaderContent, setRightHeaderContent] = useState<JSX.Element>(null);

    const siPromoConfig = useAppSelector((state) => state.config.siPromoConfig);

    const siPage = useMemo(() => {
        const p = location.pathname.toLowerCase();
        if (p.startsWith('/workspacestore')) return SI_INFOCARD_PAGES.WORKSPACESTORE;
        if (p.startsWith('/reports'))        return SI_INFOCARD_PAGES.REPORTS;
        if (p.startsWith('/pnltracker/statement')) return SI_INFOCARD_PAGES.PNL_STATEMENT;
        return null;
    }, [location.pathname]);

    const SI_CARD_SECTION: Record<string, string> = {
        'si_infocard_workspace_store': 'infocard_workspacestore',
        'si_infocard_reports':         'infocard_reports',
        'si_infocard_pnl':             'infocard_pnl',
    };
    const SI_CARD_SURFACE: Record<string, string> = {
        'si_infocard_workspace_store': 'workspacestore',
        'si_infocard_reports':         'reports',
        'si_infocard_pnl':             'pnl',
    };

    useEffect(() => {
        if (user?.role !== "Agency" && siPage && isSIPromoEnabled(siPromoConfig, siPage.promoKey)) {
            trackSIPromoShown("infocard", siPage.cardId, SI_CARD_SURFACE[siPage.promoKey]);
        }
    }, [siPage?.promoKey, user?.role]);

    const [searchParams, setSearchParams] = useSearchParams();

    const updateNotifcationStatus = async (id: number) => {
        try {
            const data = await RestS.updateNotificationStatusById(id, 1);
            return data;
        } catch (error) {
            throw new Error(error);
        }
    };

    useEffect(() => {
        console.log('location', location)
        /**
         * Send user activity to GA
         * If user activity is not sent today, send it
         */

        if (!user) return;

        try {
            const userActivitySentOnObj = localStorage.getItem("userActivitySentOn")
                ? JSON.parse(localStorage.getItem("userActivitySentOn"))
                : {};

            const userActivitySentOn = userActivitySentOnObj[user?.id];

            if (
                !userActivitySentOn ||
                userActivitySentOn != moment().format("DD-MM-YY").toString()
            ) {
                console.log("userActivitySentOn", {
                    [GADimensions.userLoginId]: user?.id,
                    [GADimensions.userType]: user?.role,
                    [GADimensions.companyName]: user?.companyName,
                    [GADimensions.companyId]: user?.companyId,
                });
                RestS.updateLoginHistory()
                    .then((res) => { console.log(res) })
                    .catch(() => { });
                localStorage.setItem(
                    "userActivitySentOn",
                    JSON.stringify({
                        ...userActivitySentOnObj,
                        [user.id]: moment().format("DD-MM-YY").toString(),
                    }),
                );
                GASendEvent(user, GAEvents.user_activity, {
                    [GADimensions.userLoginId]: user?.id,
                    [GADimensions.userType]: user?.role,
                    [GADimensions.companyName]: user?.companyName,
                    [GADimensions.companyId]: user?.companyId,
                });
            }
        } catch (error) {
            console.log("error", error)
        }

    }, []);

    const handleTrackerNavigation = async (notification: Notification) => {
        try {
            const data = await updateNotifcationStatus(notification.id).then(
                (data) => {
                    dispatch(changeResetStatus({ type: "collaboration", value: true }));
                    return data;
                },
            );
            dispatch(resetFromCollaboration());
            navigate("/collaboarationHub", {
                replace: true,
                state: { trackerId: notification.referenceId },
            });
        } catch (error) {
            //
        }
    };

    const handleChatNavigation = (notification: Notification) => {
        dispatch(resetFromCollaboration());
        navigate("/collaboarationHub", {
            replace: true,
            state: { channelId: notification.referenceId },
        });
    };

    const onClickFlashMessage = (notification: Notification) => {
        switch (notification.notificationEvent) {
            case 1:
            case 2:
            case 3:
            case 5:
                handleChatNavigation(notification);

                break;
            case 4:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
                handleTrackerNavigation(notification);
                break;

            default:
                break;
        }
    };

    // const notify = (notification: Notification) => toast(({ closeToast, toastProps }) => {
    //
    //   return (
    //     <div className={styles.notificationMain}>
    //       <div className={styles.body} onClick={() => {
    //         onClickFlashMessage(notification);
    //         closeToast();
    //       }}>
    //         <div>
    //           {getParsedMessage(notification.notificationBody["title"])}
    //         </div>
    //         <div className={styles.time}>
    //           {getRelativeTime(notification.sendTime)}
    //         </div>
    //       </div>
    //       <div className={styles.removeContainer} onClick={closeToast}>
    //         <CloseIcon />
    //       </div>
    //     </div>
    //   )
    // });

    const notify = (
        notification: Notification,
        error: boolean = false,
        config: any = {},
    ) => {
        toast(
            ({ closeToast }) => (
                <NotificationMsg
                    closeToast={closeToast}
                    onClickFlashMessage={() => onClickFlashMessage(notification)}
                    notification={notification}
                />
            ),
            {
                hideProgressBar: config.showProgressBar
                    ? !config.showProgressBar
                    : true,
                icon: false,
                closeButton: false,
                style: {
                    top: 100,
                    padding: 0,
                },
                bodyStyle: {
                    padding: 0,
                    margin: 0,
                },
                position: "top-right",
                autoClose: error
                    ? false
                    : config.autoCloseTime
                        ? config.autoCloseTime
                        : 10000,
                onClose: () => (config.closeAction ? config.closeAction() : null),
            },
        );
    };

    const handleNewChat = useCallback(
        (notification: any) => {
            //
        },
        [location],
    );

    const { socket } = useSocketOnIndex(notify, handleNewChat);

    useEffect(() => {
        if (helppopup) {
            let val_set = 0;
            Object.keys(helppopup).map((innerAttr, index) => {
                if (helppopup[innerAttr]) {
                    val_set = 1;
                }
            });
            if (val_set == 1) {
                setBlurScreen(true);
            } else {
                setBlurScreen(false);
            }
        }
    }, [helppopup]);

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    // useEffect(() => {

    //     if (import.meta.env.VITE_MAINTAINANCE_MODE == 'ON') {
    //         toast(({ closeToast }) => (
    //             <div className={styles.notificationBar}>
    //                 <div className={`${styles.statusBar} ${styles.red}`}>

    //                 </div>
    //                 <div className={styles.notificationMain}>
    //                     <div className={styles.body}>
    //                         <div className={styles.title}>
    //                             Merito is Upgrading!
    //                         </div>
    //                         <div className={styles.time}>
    //                             A scheduled system upgrade is happening from
    //                             July 31, 9:30 PM IST to August 1, 9 AM IST.
    //                             <br /> <br />
    //                             Certain features may be disabled during this time.
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //         ), {
    //             position: "top-right",
    //             toastId: "maintainanceMode",
    //             style: {
    //                 top: 48,
    //                 padding: 0,
    //             },
    //             bodyStyle: {
    //                 padding: 0,
    //                 margin: 0,
    //             },
    //             hideProgressBar: true,
    //             closeButton: false,
    //             autoClose: false,
    //             closeOnClick: false,
    //             draggable: false,
    //         })
    //     }
    // }, [])

    useEffect(() => {
        if (import.meta.env.VITE_MAINTAINANCE_MODE == 'ON') {
            toast(({ closeToast }) => (
                <div className={styles.notificationBar}>
                    <div className={`${styles.statusBar} ${styles.red}`}>

                    </div>
                    <div className={styles.notificationMain}>
                        <div className={styles.body}>
                            <div className={styles.title}>
                                Merito is Upgrading!
                            </div>
                            <div className={styles.time}>
                                A scheduled system upgrade is happening from
                                July 31, 9:30 PM IST to August 1, 9 AM IST.
                                <br /> <br />
                                Certain features may be disabled during this time.
                            </div>
                        </div>
                    </div>
                </div>
            ), {
                position: "top-right",
                toastId: "maintainanceMode",
                style: {
                    top: 48,
                    padding: 0,
                },
                bodyStyle: {
                    padding: 0,
                    margin: 0,
                },
                hideProgressBar: true,
                closeButton: false,
                autoClose: false,
                closeOnClick: false,
                draggable: false,
            })
        }
    }, [])

    useEffect(() => {
        if (workspace) {
            let val_set = 0;
            Object.keys(workspace).map((innerAttr, index) => {
                if (workspace[innerAttr]) {
                    val_set = 1;
                }
            });
            if (val_set == 1) {
                setBlurScreen(true);
            } else {
                setBlurScreen(false);
            }
        }
    }, [workspace]);

    const resetHeaderContent = () => {
        setHeaderContent(null);
    };

    useEffect(() => {
        if (auth) {
            UsersRestS.verifyJWT().then((res) => {
                setAuth(res);
                // if (auth) {
                //   document.title = "Merito - " + getCapital(getLocalUser().name) + "'s Data Hub";
                // } else {
                //   document.title = "Merito";
                // }
            }).catch(() => {
                navigate(`/login?redirect_uri=${window.location}`);
            });;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    window.onload = () => {
        if (
            localStorage.getItem("refresed") == "true" &&
            new Date().getTime() < Number(localStorage.getItem("refreshExpiry"))
        ) {
            notify({
                notificationBody: {
                    title: `${localStorage.getItem("refreshReportName")
                        ? localStorage.getItem("refreshReportName")
                        : "Workspace"
                        } has been refreshed for this month`,
                    status: ToastifyStatus.success,
                },
            } as any);
        }
        localStorage.removeItem("refresed");
        localStorage.removeItem("refreshExpiry");
        localStorage.removeItem("refreshReportName");
    };


    const isDisbursement = location.pathname.includes('disbursement')

    return auth ? (
        isDisbursement ?
            <Outlet
                context={{ headerContent, setHeaderContent, resetHeaderContent, rightHeaderContent, setRightHeaderContent }}
            />
            :
            <div className={`${styles.page} ${blurScreen ? styles.blurdata : ""}`}>
                {/* <Sidebar /> */}
                <div className={styles.layoutMainBody}>
                    <div
                        className={`${styles.headerContainer}`}
                    >
                        <Header
                            rightHeaderContent={rightHeaderContent}
                        >{headerContent}</Header>
                    </div>
                    {noSideBarLocation.includes(
                        window.location.pathname.split("/")[1].toLowerCase(),
                    ) ? (
                        <Outlet
                            context={{ headerContent, setHeaderContent, resetHeaderContent, rightHeaderContent, setRightHeaderContent }}
                        />
                    ) : (
                        <div style={{ display: "flex", width: "100vw" }}>
                            <Sidebar />
                            <div id="page_body" className={`${styles.pageBody}`}>
                                <Outlet
                                    context={{
                                        headerContent,
                                        setHeaderContent,
                                        resetHeaderContent,
                                        rightHeaderContent,
                                        setRightHeaderContent
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
                {user?.role !== "Agency" && siPage && isSIPromoEnabled(siPromoConfig, siPage.promoKey) && (
                    <>
                        <InfoCard
                            id={siPage.cardId}
                            chipId={siPage.chipId}
                            icon={<img src={sparkleGif} alt="" />}
                            title="Check out Supplier Intelligence"
                            body="For insights into your suppliers and their impact on your cash flow."
                            action={{ label: 'View', onClick: () => { trackSIPromoButtonClicked("View", SI_CARD_SECTION[siPage.promoKey]); navigate('/supplier-intelligence'); } }}
                            onDismiss={() => trackSIPromoDismissed("infocard", siPage.cardId, SI_CARD_SURFACE[siPage.promoKey])}
                        />
                        <Chip
                            id={siPage.chipId}
                            label="Supplier Intelligence"
                            cardId={siPage.cardId}
                        />
                    </>
                )}
                <ToastContainer
                    style={{
                        padding: "0px",
                    }}
                />
            </div>
    ) : (
        <Navigate to={`/login${location.search}`} state={{ from: location }} />
    );
}

export default Layout;
